import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import sysi_logo from '../images/sysi_logo.jpg';
import influencer_logo from '../images/influencer_logo.jpg';
import achieve_logo from '../images/a-chieve_logo.jpg';
import doplus_logo from '../images/doplus_logo.jpg';
import newgeneration_logo from '../images/new-generation_logo.jpg';
import thoughtworks_logo from '../images/thoughtworks_logo.jpg';
import aboutus from '../images/aboutus.jpg';

import SEO from '../components/seo';
import Layout from '../components/Layout';

const useStyles = makeStyles(() => ({
  logo: {
    maxHeight: 120,
    margin: 0,
  },
}));

const AboutUs = () => {
  const styles = useStyles();
  return (
    <Layout>
      <SEO
        title={'เกี่ยวกับเรา • About Us'}
        description={
          '“สมาคมคนรุ่นใหม่กับนวัตกรรมทางสังคม (SYSI)" เกิดขึ้นจากการต่อยอดการทำงานพัฒนาเยาวชนคนรุ่นใหม่ภายใต้โครงการพัฒนาคนรุ่นใหม่เพื่อการเปลี่ยนแปลงสังคม โดยมูลนิธิอาสาสมัครเพื่อสังคม'
        }
      />
      <Box py={{ xs: 2, sm: 4, md: 5 }}>
        <Container maxWidth={'md'}>
          <Container maxWidth={'sm'}>
            <img alt={'doodles'} src={aboutus} />
          </Container>
          <h1>จุดเริ่มต้นของสมาคมคนรุ่นใหม่กับนวัตกรรมทางสังคม (SYSI)</h1>
          <p>
            “สมาคมคนรุ่นใหม่กับนวัตกรรมทางสังคม (SYSI)"
            เกิดขึ้นจากการต่อยอดการทำงานพัฒนาเยาวชนคนรุ่นใหม่ภายใต้โครงการพัฒนาคนรุ่นใหม่เพื่อการเปลี่ยนแปลงสังคม
            โดยมูลนิธิอาสาสมัครเพื่อสังคม
          </p>
          <p>
            ตั้งแต่ปี 2555 จนถึงปัจจุบัน โครงการพัฒนาคนรุ่นใหม่ฯ
            ได้พัฒนาเยาวชนคนรุ่นใหม่มาแล้ว 3 รุ่น จำนวน 116 คน
            ด้วยการสนับสนุนการจัดกระบวนการเรียนรู้ ที่เปิดกว้าง เรียนรู้ ยอมรับ
            เข้าใจ และเคารพความแตกต่างหลากหลาย มีภาวะผู้นำ มั่นใจ มุ่งมั่น
            รวมถึงการพัฒนาทักษะการคิดวิเคราะห์เชื่อมโยงตนเองกับการเปลี่ยนแปลงที่เกิดขึ้นในชุมชนและสังคม
            ทั้งในระดับกว้างและลึก
          </p>
          <p>
            โดยคนรุ่นใหม่ทั้ง 3 รุ่น ได้ผ่านกระบวนการเรียนรู้ 4 ลักษณะ คือ
            เรียนรู้ในห้องเรียน, เรียนรู้กับชุมชนและทำกิจกรรมอาสาสมัคร,
            การออกไปแลกเปลี่ยนเรียนรู้-ศึกษาดูงาน และการทำโครงการนวัตกรรม
            (Social Innovation Project) ซึ่งจากการประเมินผลโครงการฯ
            พบว่าหนึ่งในสิ่งที่โดดเด่นคือการทำโครงการนวัตกรรมสร้างสรรค์ของเยาวชน
            ที่ส่งผลให้คนรุ่นใหม่ยกระดับความรู้ ความเข้าใจทางสังคม
            พัฒนาทักษะการทำงาน
            และเกิดผลต่อยอดจากการทำโครงการระดับพื้นที่ไปสู่การทำงานในระดับภูมิภาคและขยายผลสู่ระดับนโยบายทั้งในส่วนของท้องถิ่นหรือประเทศได้
          </p>
          <p>
            จากผลที่ลัพธ์และบทเรียนที่ทีมงานได้รับตลอดการดำเนินงาน โครงการ
            <b>
              <i>“เครือข่ายนวัตกรรมคนรุ่นใหม่” </i>
            </b>
            จึงเกิดขึ้นเพื่อเปิดโอกาสและสนับสนุนให้คนรุ่นใหม่คิด
            ริเริ่มโครงการหรือพัฒนา สานต่อการทำงานของตนเอง ตามระดับประสบการณ์
            ความพร้อม ความสนใจ ของพวกเขาเอง โดยมีหัวใจของกระบวนการคือ
            การเปิดโอกาส ได้ทดลอง ปล่อยของ ทำจริง เปิดพื้นที่การเรียนรู้
            เรียนรู้ผ่านประสบการณ์ เสริมพลังทั้งจากภายในและภายนอก
          </p>
          <br />
          <h3>เบื้องหลังทีมดำเนินการของเครือข่ายนวัตกรรมคนรุ่นใหม่</h3>
          <br />
          <Grid container spacing={4} justify={'center'}>
            <Grid item>
              <img className={styles.logo} alt={'sysi logo'} src={sysi_logo} />
            </Grid>
            <Grid item>
              <img
                className={styles.logo}
                alt={'influencer logo'}
                src={influencer_logo}
              />
            </Grid>
            <Grid item>
              <img
                className={styles.logo}
                alt={'achieve logo'}
                src={achieve_logo}
              />
            </Grid>
            <Grid item>
              <img
                className={styles.logo}
                alt={'doplus logo'}
                src={doplus_logo}
              />
            </Grid>
            <Grid item>
              <img
                className={styles.logo}
                alt={'new generation logo'}
                src={newgeneration_logo}
              />
            </Grid>
            <Grid item>
              <img
                className={styles.logo}
                alt={'new generation logo'}
                src={thoughtworks_logo}
              />
            </Grid>
          </Grid>
          <p>
            เครือข่ายนวัตกรรมคนรุ่นใหม่ ดำเนินการโดย{' '}
            <b>
              <i>สมาคมคนรุ่นใหม่กับนวัตกรรมทางสังคม</i>
            </b>{' '}
            ที่เกิดจากการรวมตัวกันขององค์กรคนรุ่นใหม่ 4 องค์กร
            ที่เติบโตขึ้นมาจากโครงการพัฒนาคนรุ่นใหม่เพื่อการเปลี่ยนแปลงสังคมทั้ง
            3 รุ่น ตลอดระยะเวลา 6 ปีที่ผ่านมา ได้แก่
            เครือข่ายคนรุ่นใหม่เพื่อการเปลี่ยนแปลงสังคม, ธุรกิจเพื่อสังคมอาชีฟ
            (a-chieve), บริษัท Influencer จำกัด และกลุ่ม Dot to Dot เพื่อนำทักษะ
            ความถนัด
            ความสามารถที่แต่ละองค์กรมีมาทำงานร่วมกันให้เกิดการทำงานอย่างมีประสิทธิภาพและต่อเนื่องที่สุด
          </p>
          <br />
          <h3>พัฒนาทั้งคนทำงานและนวัตกรรมสังคมไปพร้อมๆ กัน</h3>
          <p>
            <b>
              <i>สมาคมคนรุ่นใหม่กับนวัตกรรมทางสังคม</i>
            </b>{' '}
            เชื่อในกระบวนการสร้างสรรค์สังคมอย่างมีส่วนร่วมที่พลเมืองหรือประชาชนเข้ามามีบทบาทในการสร้างการเปลี่ยนแปลงและพัฒนาสังคม
          </p>
          <p>
            ในระยะยาว สมาคมฯ
            มุ่งหวังทำให้สังคมพัฒนาขึ้นจากการที่คนรุ่นใหม่เข้ามามีบทบาทพัฒนาชุมชนและสังคมของตนเอง
            เกิดคนรุ่นใหม่ที่เปลี่ยนแปลงตนเองเป็น Active Citizen
            และสนับสนุนให้คนรุ่นใหม่เหล่านี้ทำงานเปลี่ยนแปลงสังคมร่วมกันเป็นเครือข่าย
          </p>
          <p>
            สมาคมฯ ยังส่งเสริมให้เกิดนวัตกรรมทางสังคมรูปแบบใหม่ ๆ
            ในหลากหลายบริบท
            เพื่อเป็นเครื่องมือทำให้ชุมชนและสังคมเกิดการพัฒนาไปสู่ภาพที่ต้องการเห็น
          </p>
          <p>
            คนรุ่นใหม่ที่เข้าร่วมโครงการจึงได้รับการพัฒนาศักยภาพทั้งในการเข้าใจประเด็นทางสังคม
            การแก้ปัญหาในเชิงโครงสร้าง ทักษะการบริหารโครงการ
            ไปจนถึงการเข้าใจตนเองและเข้าใจผู้อื่น สมาคมฯ
            สนับสนุนพัฒนาการของผู้เข้าร่วมทั้งในระดับบุคคล ระดับทีม และระดับรุ่น
            ดูแลทั้งเรื่องการดำเนินโครงการนวัตกรรม ตลอดจนดูแลมิติอื่นๆ ของชีวิต
            เป็นเพื่อนและกำลังใจในการดำเนินงานด้านสังคมกันต่อไปในระยะยาว
          </p>
          <p>
            หัวใจของการพัฒนาผู้นำการเปลี่ยนแปลงสังคม (Change Agent)
            ของสมาคมประกอบด้วย 4 ด้าน
          </p>
          <ol>
            <li>
              ทุน (Funding) :
              สนับสนุนทรัพยากรทางการเงินเพื่อให้ผู้เข้าร่วมได้มีพื้นที่ทดลอง
            </li>
            <li>
              อบรม (Training) :
              ผ่านหลักสูตรที่เป็นพื้นฐานและหัวข้อที่ผู้เข้าร่วมสามารถเลือกเรียนในเรื่องที่ตนเองสนใจได้
              ติดเครื่องมือให้ผู้เข้าร่วมทำโครงการได้อย่างมีคุณภาพ
              รวมถึงได้เรียนรู้พัฒนาตนเองและพัฒนาทีมงาน
            </li>
            <li>
              ลงพื้นที่ติดตาม (Supporting and Networking) :
              ทีมงานเครือข่ายนวัตกรรมคนรุ่นใหม่จะลงพื้นที่ติดตามเพื่อรู้จักและเข้าใจผู้เข้าร่วมมากขึ้น
              พัฒนาการทำงาน และเชื่อมโยงคนรุ่นใหม่เข้าด้วยกัน
            </li>
            <li>
              ใส่ใจงาน ความคิด ชีวิต และจิตใจ :
              แม้ว่าการทำโครงการให้ลุล่วงเป็นภารกิจที่ทีมงานคาดหวังกับผู้เข้าร่วม
              แต่การใส่ใจกันและกันในมิติอื่น ๆ ของชีวิต
              ไม่ว่าจะเป็นเรื่องสภาวะจิตใจ ความคาดหวังต่ออนาคต
              ปัญหาที่กำลังเผชิญ ก็เป็นเรื่องที่ทีมงานใส่ใจเช่นกัน
              เพราะสิ่งเหล่านี้เป็นรากฐานที่จะหล่อเลี้ยงความสัมพันธ์ระหว่างทั้งทีมงานและเพื่อนร่วมรุ่นที่จะเดินทางไปด้วยกันบนเส้นทางสายนี้
            </li>
          </ol>
          <br />
          <h3>ภาพสุดท้ายของสังคมที่เราอยากจะเห็น</h3>
          <p>
            สมาคมฯ
            อยากเห็นคนรุ่นใหม่มีไอเดียในการพัฒนาสังคมและลุกขึ้นมาเป็นส่วนหนึ่งในการสร้างการเปลี่ยนแปลงสังคม
            ในระดับที่กว้างขึ้นเรื่อย ๆ ทั้งในเชิงจำนวน พื้นที่ ความหลากหลาย
            และระดับความลึกของประเด็น
          </p>
          <p>
            สมาคมฯ
            พร้อมพัฒนาเพื่อรองรับกลุ่มคนรุ่นใหม่ที่จะเข้ามาใช้พื้นที่นี้อย่างกว้างขวางและหลากหลายมากขึ้น
          </p>
        </Container>
      </Box>
    </Layout>
  );
};

AboutUs.propTypes = {};
AboutUs.defaultProps = {};

export default AboutUs;
